import { themeVars } from '../theme/vars';
import { borderRadius, boxShadows, space } from '../tokens';
import { typography } from '../typography';
import { style } from '../layer.css';

export const comboboxContainer = style({
  width: '100%',
});

export const comboboxLabel = style({
  ...typography.labelSm,
  display: 'block',
  color: themeVars.controls.foreground.label,
  marginBottom: space.s4,
});

export const comboboxWrapper = style({
  display: 'flex',
  flexDirection: 'column',
  position: 'relative',
  gap: space.s8,
  height: '100%',
  outline: `1px solid ${themeVars.controls.border.default}`,
  borderRadius: borderRadius.r8,
  maxHeight: 150,
  overflowY: 'auto',
  minHeight: '48px', // shouldn't it have same height as other inputs?
  color: themeVars.container.foreground.primary,
  outlineOffset: -1,
  padding: `${space.s8}px ${space.s32}px ${space.s8}px ${space.s16}px`,

  ':hover': {
    outlineColor: themeVars.controls.border.hover,
  },
});

export const comboboxIsFocused = style({
  outline: `1px solid ${themeVars.controls.border.active}`,
});

export const comboboxError = style({
  outline: `1px solid ${themeVars.controls.border.critical}`,
});

export const comboboxInputContainer = style({
  display: 'inline-flex',
  rowGap: space.s8,
  columnGap: space.s8,
  alignItems: 'center',
  flexWrap: 'wrap',
  flex: 1,
  ...typography.bodyMd,
});

export const comboboxInputWrapper = style({
  display: 'flex',
  gap: '2px',
  flexGrow: 1,
});

export const comboboxInput = style({
  width: '100%',
  border: 0,
  outline: 'none',
  backgroundColor: 'transparent',
  height: '100%',

  selectors: {
    '&::placeholder': {
      color: themeVars.controls.foreground.default,
    },
  },
});

export const comboboxMenu = style({
  overflow: 'hidden',
  width: 'var(--radix-popover-trigger-width)',
  display: 'flex',
  flexDirection: 'column',
  backgroundColor: themeVars.container.primary.background.idle,
  borderRadius: borderRadius.r8,
  maxHeight: `min(calc(var(--radix-popover-content-available-height) - ${space.s8}px), 580px)`,
  margin: 0,
  padding: 0,
  outline: `1px solid ${themeVars.container.border.default}`,
  outlineOffset: '-1px',
  boxShadow: boxShadows.default,
});

export const comboboxMenuItem = style({
  display: 'flex',
  flexDirection: 'column',
  backgroundColor: themeVars.dropdownMenu.background.default,
  borderRadius: borderRadius.r8,
  transition: 'background-color 0.15s ease-in-out',
});

export const spinner = style({
  position: 'absolute',
  right: space.s4,
  bottom: 0,
  padding: space.s4,
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  top: 0,
});

export const inputError = style([
  typography.bodySm,
  {
    color: themeVars.container.foreground.critical,
    marginTop: space.s4,
  },
]);
